import { FaPencilAlt } from "react-icons/fa";
import { useRef } from "react";
import { FaArrowRight } from "react-icons/fa";

const Partnership = () => {

  const videoRef = useRef(null);

  const togglePlay = () => {
    const video = videoRef.current;
    if (!video) return;

    if (video.paused) {
      video.muted = false;
      video.play();
    } else {
      video.pause();
    }
  };

  return (
    <>
    <section className="section-padding">
      <div className="container">
        <div className="text-center">
          <h2 className="mb-5">International Partnership</h2>
        </div>
        <div className="partnership-wrapper">
          <img src="assets/images/banner/smrt.webp" alt="NIE C-SMRT" className="img-fluid" />
          <img src="assets/images/banner/edu-tech.webp" alt="NIE C-Edu Tech" className="img-fluid" />
          <img src="assets/images/banner/toefl-logo.png" alt="TOEFL" className="img-fluid" />
          <img src="assets/images/banner/duolingo-potrait.svg" alt="Duolingo" className="img-fluid" />
          <img src="assets/images/banner/iPass.png" alt="iPass" className="img-fluid" />
        </div>

        {/* <div className="text-center pt-5 mt-5">
          <h5>Not Sure Your English Level? Let's Find Out!</h5>
          <p>Take our quick placement test and start learning with the right class.</p>
          <a href="https://placement-test.niecindonesia.com/" target="_blank" className="btn btn-main rounded">
            <span className="d-flex align-items-center gap-2">
              <FaPencilAlt /> Test your English now
            </span>
          </a>
        </div>           */}
      </div>      
    </section>     
    </> 
  );
}

export default Partnership;